import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { semanticColors } from "../../Globals/styles";
import WeekDay from "./weekDay";
import NumberInput from "../../Common/numberInput";

class PeriodRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fifty: this.props.period.fifty,
      hundred: this.props.period.hundred,
      shack: this.props.period.shack,
      transport: this.props.period.transport,
      afspads: this.props.period.afspads,
    };
  }
  shouldComponentUpdate = (nextProps) => {
    //if there is no updateObject always update
    if (!nextProps.updateObject) return true;

    //if periodId is not defined in updateObject always update
    if (!nextProps.updateObject.periodId) return true;

    //if period id is defined and equal this period id, update.
    if (nextProps.updateObject.periodId === this.props.period.id) return true;

    //if there is a second updateObject do same logic
    if (nextProps.updateObject.secondObject)
      if (nextProps.updateObject.secondObject.periodId === this.props.period.id)
        return true;

    //if its sorted by project and if the period is for the updated employee
    if (
      !this.props.isSortedByEmployee &&
      this.props.period.employeeId === nextProps.updateObject.employeeId
    )
      return true;

    return false;
  };
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.period.fifty !== this.props.period.fifty) {
      this.setState({
        fifty: nextProps.period.fifty,
      });
    }
    if (nextProps.period.hundred !== this.props.period.hundred) {
      this.setState({
        hundred: nextProps.period.hundred,
      });
    }
    if (nextProps.period.shack !== this.props.period.shack) {
      this.setState({
        shack: nextProps.period.shack,
      });
    }
    if (nextProps.period.transport !== this.props.period.transport) {
      this.setState({
        transport: nextProps.period.transport,
      });
    }
  };
  getProjectTd = () => {
    const { getProject, period } = this.props;
    let project = getProject(period.projectId);
    return (
      <td style={styles.tdCenter} rowSpan="2">
        {project.number}
        <br />
        {project.name}
      </td>
    );
  };
  getEmployeeTd = () => {
    const {
      getEmployee,
      period,
      getEmployeeTotalSum,
      getEmployeeTotalSum2,
      getEmployeeTotalOvertTimeSum,
    } = this.props;
    let employee = getEmployee(period.employeeId);
    const overtime = getEmployeeTotalOvertTimeSum(employee.id);
    return [
      <td key="empNumber" rowSpan="2" style={styles.tdCenter}>
        {employee.number}
      </td>,
      <td key="empName" rowSpan="2" style={styles.tdCenter}>
        <div>{employee.name}</div>
        <div>
          Total antal timer: {getEmployeeTotalSum(employee.id)}{" "}
          <span>
            {" / "}
            <span>{getEmployeeTotalSum2(employee.id)}</span>
          </span>
        </div>
        {overtime > 0 ? (
          <div style={{ color: semanticColors.danger }}>
            Overtid: {overtime}
          </div>
        ) : null}
      </td>,
    ];
  };
  onPeriodInputBlur = (type) => {
    const { updatePeriodInput, period } = this.props;
    let updateObject = {
      periodId: period.id,
      employeeId: period.employeeId,
      projectId: period.projectId,
    };
    updatePeriodInput(period.id, type, this.state[type], updateObject);
  };
  render() {
    const {
      startWeek,
      endWeek,
      period,
      getDay,
      isSortedByEmployee,
      getEmployee,
      openCalculator,
      setOpenCalculator,
      updateDay,
      conflictingProjects,
    } = this.props;
    let employee = getEmployee(period.employeeId);
    if (!employee) {
      employee = { wage: 0, latestSupplementRate: 0 };
    }
    let firstWeek = [];
    let secondWeek = [];
    let sum = 0;
    let overTime = 0;
    let supplement = 0;
    let mileageSum = 0;
    let shackSum = 0;

    period.weeks.forEach((dayId, index) => {
      let weekDay = getDay(dayId);
      let updateObject = {
        periodId: period.id,
        employeeId: period.employeeId,
        projectId: period.projectId,
        dayId: dayId,
      };
      let appendedUpdateDay = (
        dayId,
        normalHours,
        supplementRate,
        supplementHours,
        mileageNew,
        shackNew,
        absenceCode
      ) =>
        updateDay(
          dayId,
          normalHours,
          supplementRate,
          supplementHours,
          mileageNew,
          shackNew,
          absenceCode,
          updateObject
        );
      sum += weekDay.normalHours;
      overTime += weekDay.nightHoursOrig;
      supplement += weekDay.supplementRate * weekDay.supplementHours;

      mileageSum += weekDay.mileageNew;
      shackSum += weekDay.shackNew;

      if (index < 7) {
        firstWeek.push(
          <WeekDay
            {...weekDay}
            id={dayId}
            key={dayId}
            openCalculator={openCalculator}
            setOpenCalculator={(id) => setOpenCalculator(id, updateObject)}
            employeeWage={employee.wage}
            latestSupplementRate={employee.latestSupplementRate}
            updateDay={appendedUpdateDay}
            updateObject={this.props.updateObject}
            conflictingProjects={conflictingProjects}
          />
        );
      } else {
        secondWeek.push(
          <WeekDay
            {...weekDay}
            id={dayId}
            key={dayId}
            openCalculator={openCalculator}
            setOpenCalculator={(id) => setOpenCalculator(id, updateObject)}
            employeeWage={employee.wage}
            latestSupplementRate={employee.latestSupplementRate}
            updateDay={appendedUpdateDay}
            updateObject={this.props.updateObject}
            conflictingProjects={conflictingProjects}
          />
        );
      }
    });
    return (
      <tbody style={styles.tbody}>
        {/*Start first row*/}
        <tr style={styles.tr}>
          {!isSortedByEmployee ? this.getEmployeeTd() : this.getProjectTd()}
          <td style={[styles.tdCenter, styles.weekNumber]}>{startWeek}</td>
          {firstWeek}
          <td style={styles.tdWidth} rowSpan="2">
            {sum}
          </td>
          <td style={styles.tdWidth} rowSpan="2">
            {employee.wage}
          </td>
          <td style={styles.tdWidth} rowSpan="2">
            {supplement}
          </td>
          <td style={styles.periodInput} rowSpan="2">
            {mileageSum}
          </td>
          <td style={[styles.periodInput, styles.tdWidth]} rowSpan="2">
            {shackSum}
          </td>
          <td style={styles.periodInput} rowSpan="2">
            <input
              id="checkBox"
              type="checkbox"
              checked={
                this.state.afspads
                  ? this.state.afspads == 0
                    ? false
                    : true
                  : 0
              }
              style={{ boxShadow: "none", width: "60%" }}
              onChange={(e) => {
                if (e.target.checked) {
                  this.setState({ afspads: 1 });
                } else {
                  this.setState({ afspads: 0 });
                }
                setTimeout(() => this.onPeriodInputBlur("afspads"), 500);
              }}
            />
          </td>
          <td style={styles.periodInput} rowSpan="2">
            <NumberInput
              style={styles.input}
              onBlur={() => this.onPeriodInputBlur("hundred")}
              value={this.state.hundred}
              onChange={(val) => this.setState({ hundred: val })}
            />
          </td>
        </tr>
        {/*Start second row*/}
        <tr style={styles.tr}>
          <td style={[styles.tdCenter, styles.weekNumber]}>{endWeek}</td>
          {secondWeek}
        </tr>
        <tr style={styles.spacer}></tr>
      </tbody>
    );
  }
}

var styles = {
  tbody: {
    paddingBottom: "6px",
  },
  tr: {
    height: "40px",
  },
  tdCenter: {
    fontSize: "12px",
    textAlign: "center",
  },
  tdWidth: {
    width: "60px",
  },
  weekNumber: {
    fontWeight: "bold",
    fontSize: "14px",
  },
  periodInput: {
    width: "70px",
    height: "80px",
    padding: "0 1px",
    textAlign: "right",
  },
  input: {
    height: "80px",
    border: "0px",
  },
  spacer: {
    height: "6px",
  },
};

PeriodRow.propTypes = {
  startWeek: PropTypes.number.isRequired,
  endWeek: PropTypes.number.isRequired,
  period: PropTypes.shape({
    id: PropTypes.string.isRequired,
    employeeId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    fifty: PropTypes.number.isRequired,
    hundred: PropTypes.number.isRequired,
    shack: PropTypes.number.isRequired,
    weeks: PropTypes.array.isRequired,
    transport: PropTypes.number.isRequired,
  }).isRequired,
  getEmployee: PropTypes.func.isRequired,
  getProject: PropTypes.func.isRequired,
  getDay: PropTypes.func.isRequired,
  isSortedByEmployee: PropTypes.bool.isRequired,
  getEmployeeTotalSum: PropTypes.func.isRequired,
  openCalculator: PropTypes.string.isRequired,
  setOpenCalculator: PropTypes.func.isRequired,
  updateDay: PropTypes.func.isRequired,
  updatePeriodInput: PropTypes.func.isRequired,
  updateObject: PropTypes.object,
  conflictingProjects: PropTypes.object.isRequired,
};
export default Radium(PeriodRow);



// WEBPACK FOOTER //
// ./src/App/Project/Salary/periodRow.jsx